<template>
    <nav>
        <ul class="pagination">
            <li v-bind:class="{ disabled: currentPage == 1 }">
                <a href="javascript:void(0);" @click="update(currentPage-1)">
                    <i class="material-icons">chevron_left</i>
                </a>
            </li>

            <li v-bind:class="{ disabled: currentPage == 1 }">
                <a class="waves-effect" @click="update(1)">1</a>
            </li>

            <li v-for="(items, index) in offset" v-bind:class="{ disabled: currentPage == items }" v-if="index != 0 && currentPage < offset">
                <a class="waves-effect" @click="update(items)">{{ items }}</a>
            </li>

            <li class="disabled" v-if="maxPage > maxOffset && currentPage >= offset"><a>...</a></li>
            <li v-if="currentPage >= offset && currentPage <= maxPage - maxOffset + 1"><a class="waves-effect" @click="update(currentPage-1)">{{ currentPage-1 }}</a></li>
            <li v-if="currentPage >= offset && currentPage <= maxPage - maxOffset + 1" class="disabled"><a class="waves-effect" @click="update(currentPage)">{{ currentPage }}</a></li>
            <li v-if="currentPage >= offset && currentPage <= maxPage - maxOffset + 1"><a class="waves-effect" @click="update(currentPage+1)">{{ currentPage+1 }}</a></li>


            <li class="disabled" v-if="maxPage > maxOffset && currentPage <= maxPage - maxOffset + 1"><a>...</a></li>

            <li v-for="(items, index) in offset" v-bind:class="{ disabled: currentPage == items+maxPage-maxOffset }" v-if="maxPage > maxOffset && index != maxOffset-1  && currentPage >= (maxPage - maxOffset+2)">
                <a class="waves-effect" @click="update(items+maxPage-maxOffset)">{{ items+maxPage-maxOffset }}</a>
            </li>

            <li v-bind:class="{ disabled: currentPage == maxPage }" v-if="maxPage > maxOffset"><a class="waves-effect" @click="update(maxPage)">{{ maxPage }}</a></li>
            <li v-bind:class="{ disabled: currentPage == maxPage }">
                <a href="javascript:void(0);" class="waves-effect" @click="update(currentPage+1)">
                    <i class="material-icons">chevron_right</i>
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
  export default {
    name: 'Pagination',
    props: [
      'total-rows', 'per-page', 'value'
    ],
    data: function () {
      return {
        currentPage: this.value,
        maxOffset: 5
      }
    },
    methods: {
      update: function (currentPage) {
        if (currentPage < 1 || currentPage > this.maxPage) return
        this.currentPage = currentPage
        this.$emit('input', this.currentPage)
      }
    },
    computed: {
      offset: function () {
        if (this.totalRows == null || this.perPage == null) return 1
        const result = Math.ceil(this.totalRows / this.perPage)
        if (result < 1) return 1
        else if (result > this.maxOffset) return this.maxOffset
        else return result
      },
      maxPage: function () {
        if (this.totalRows == null || this.perPage == null) return 1
        const result = Math.ceil(this.totalRows / this.perPage)
        return (result < 1) ? 1 : result
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Pagination.vue